import { useMutation } from '@tanstack/react-query';
import httpv2 from 'apis/httpv2';
import http from 'apis/http';
import { MutationConfig, ReportOrderDto } from 'types';

interface CreateReportOrderOptions {
  path: string;
  data: unknown;
}

export const createReportOrder = ({ path, data }: CreateReportOrderOptions) => {
  if (path.includes('accounting-lines')) {
    return http.post<ReportOrderDto | ReportOrderDto[]>(path, data);
  }
  return httpv2.post<ReportOrderDto | ReportOrderDto[]>(path, data);
};

interface UseCreateReportOrderOptions {
  mutationConfig?: MutationConfig<typeof createReportOrder>;
}

export const useCreateReportOrder = ({ mutationConfig }: UseCreateReportOrderOptions = {}) => {
  const config = mutationConfig || {};

  return useMutation({
    ...config,
    mutationFn: createReportOrder,
  });
};
